import * as Actions from './actions/actions';
import reducer from './reducers/index';
import { settings } from '../../../settings/settings-util'
import mobileDetect from 'mobile-detect'
import watch from 'redux-watch'

export default class MobileDeviceDetector {
    constructor(passedSettings) {
         this._settings = passedSettings || settings;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    initialize(store, initializationPromises) {
        this._store = store;
        this._initializationPromises = initializationPromises;
        this.detectDeviceType();
    }

    getReducer() {
        return reducer;
    }

    async detectDeviceType() {
        await this._initializationPromises.onLoad;

        const deviceType = this.getDeviceType();
        this._store.dispatch(Actions.setDeviceType({ deviceType }));
    }

    getDeviceType() {
        let userAgent = navigator.userAgent || '';
        let md = new mobileDetect(userAgent);

        if(!md.mobile()) {
            return this._settings.mobileConstants.deviceTypes.desktop;
        }

        return !md.tablet() ? this._settings.mobileConstants.deviceTypes.mobile : this._settings.mobileConstants.deviceTypes.tablet;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/mobile-device-detector/src/mobile-device-detector.js